// 0x08(GetBatteryStatus) の復号後応答をパースする。
// readAesResponse の戻り number[] を直接読むため hex 文字列パースは介在せず、NaN ガードは不要。
// platform StandPowerData 相当: commandCode=data[0] / resultOK=data[2]==0x00 / electricity=data[3]。
export function parseStandPowerData(decoded: number[]): {
  commandCode: number
  resultOK: boolean
  battery: number
} {
  return {
    commandCode: decoded[0],
    resultOK: decoded[2] === 0x00,
    battery: decoded[3],
  }
}
